import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { ClientContactDO, ClientEmailDO } from 'app/BaseFramework/shared/models'

export interface EmailPhoneDO {
  typeCd: any,
  value: any,
  prefferedFl: any,
  id: any,
}
@Component({
  selector: 'ui-multirow-basic',
  templateUrl: './ui-multirow-basic.component.html',
  styleUrls: ['./ui-multirow-basic.component.scss']
})
export class UIMultirowBasicComponent implements OnInit {

  _currentComponentName = 'UIMultirowBasicComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    public validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private notification: NzNotificationService,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService) { }

  //Declaraions which might need developer input
  uiMultirowBasicForm: FormGroup
  UIMULTIROWBASICFORMNAME = "uiMultirowBasicForm"
  lookupsToBind = ['emailTypeCd', 'phoneTypeCd']
  selectorOfThisComponent = 'app-claims-basic-details'
  parentEvent$

  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE 
   */

  //ComponentSpecific Inputs, Outputs

  @Input() type: string; /* email | mobile */
  @Input() placeholderVal: string = '';
  searchHasData: boolean = false;
  searchTerm: string = '';
  lookupTypeCd: string = '';
  item
  @Output() componentOutput = new EventEmitter<any>();
  // @Input() type: string;
  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
  };

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let isOutputValid = this.validateOutput(this.uiMultirowBasicForm)
      if (isOutputValid)
        this.EmitComponentOutput(this.uiMultirowBasicForm)
      else {
        this.EmitComponentOutput("ERROR")
      }
    })
  }

  validateOutput(o) {
    if (o) {
      this.commonUtilty.markAllFieldDirty(o);
      // return o.valid();
      return true;
    }
  }

  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    this.initializeClientSearchForm(this._inputDataForEdit)
    this.subscribeToParentEvent()

    if (this.type == "email") {
      this.lookupTypeCd = 'emailTypeCd';
      this.initiaLizeEmailListEditMode();
    } else if (this.type == "phone") {
      this.lookupTypeCd = 'phoneTypeCd';
      this.initiaLizePhoneListEditMode();
    }
  }

  initiaLizeEmailListEditMode() {
    if (this._inputDataForEdit) {
      this.emailList = this._inputDataForEdit
    }
  }
  initiaLizePhoneListEditMode() {
    if (this._inputDataForEdit) {
      this.phoneList = this._inputDataForEdit
    }
  }

  /**
   * Form Trasactions
   */

  initializeClientSearchForm(data?) {
    let payload = data || {}
    this.uiMultirowBasicForm = this.fb.group({
      typeCd: this.validationUtilService.setValidationsForFormControl('typeCd', this.UIMULTIROWBASICFORMNAME, payload['typeCd']),
      emailId: this.validationUtilService.setValidationsForFormControl('emailId', this.UIMULTIROWBASICFORMNAME, payload['emailId']),
      phone: this.validationUtilService.setValidationsForFormControl('phone', this.UIMULTIROWBASICFORMNAME, payload['phone']),
      id: this.validationUtilService.setValidationsForFormControl('id', this.UIMULTIROWBASICFORMNAME, payload['id']),
      prefferedFl: this.validationUtilService.setValidationsForFormControl('phone', this.UIMULTIROWBASICFORMNAME, payload['prefferedFl']),
    });
  }

  isRequired(fieldName) {
    let returnObj = this.validationUtilService.isRequired(fieldName, this.UIMULTIROWBASICFORMNAME)
    return returnObj
  }
  emailList: any = [];
  phoneList: any = [];

  addRow() {
    if (this.uiMultirowBasicForm.status === 'VALID') {
      if (this.type && this.type == 'email') {

        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.uiMultirowBasicForm.value.emailId)) {

          let clientEmailDO = new ClientEmailDO();
          clientEmailDO.typeCd = this.uiMultirowBasicForm.value.typeCd;
          clientEmailDO.emailId = this.uiMultirowBasicForm.value.emailId;
          if (this.emailList && this.emailList.length == 0)
            this.uiMultirowBasicForm.value.prefferedFl = true;
          clientEmailDO.prefferedFl = this.uiMultirowBasicForm.value.prefferedFl,
            clientEmailDO.id = this.uiMultirowBasicForm.value.id,
            this.emailList.push(this.commonUtilty.deepCopy(clientEmailDO));
          this.EmitComponentOutput(this.emailList)
        }
        else
          this.notification.error('Not Valid', 'Please enter valid email');
      } else if (this.type && this.type == 'phone') {

        let mob = this.uiMultirowBasicForm.value.phone
        if (mob.length < 10) {
          this.notification.error('Not Valid', 'Please enter valid mobile number');
        }
        else {
          let clientContactDO = new ClientContactDO();
          clientContactDO.typeCd = this.uiMultirowBasicForm.value.typeCd;
          clientContactDO.contactNum = this.uiMultirowBasicForm.value.phone;
          if (this.phoneList && this.phoneList.length == 0)
            this.uiMultirowBasicForm.value.prefferedFl = true;
          clientContactDO.prefferedFl = this.uiMultirowBasicForm.value.prefferedFl,
            clientContactDO.id = this.uiMultirowBasicForm.value.id,
            this.phoneList.push(this.commonUtilty.deepCopy(clientContactDO));
          this.EmitComponentOutput(this.phoneList)
        }
      }
      this.searchHasData = true;
      this.initializeClientSearchForm()
    }
  }

  removeRow(index) {
    if (this.type && this.type == 'email') {
      this.emailList.splice(index, 1)
    } else if (this.type && this.type == 'phone') {
      this.phoneList.splice(index, 1)
    }
  }
  deselectOtherEmailsPrefferedFl(preIndex) {
    this.emailList.forEach((element, index) => {
      if (preIndex != index) element.prefferedFl = false
    });
  }

  deselectOtherPhonesPrefferedFl(preIndex) {
    this.phoneList.forEach((element, index) => {
      if (preIndex != index) element.prefferedFl = false
    });
  }

  mobLengthVal = true
  onMobChange(event) {
    let mob = this.uiMultirowBasicForm.get('phone').value;
    if (mob.length < 10)
      this.mobLengthVal = false
  }
}


